import { useNavigate } from 'react-router-dom';

const useVerificatedEmail = () => {
  const navigate = useNavigate();

  const goToDashboard = async () => {
    navigate(localStorage.getItem('redirectAfterEmailVerification') || '/dashboard');
  };

  return {
    goToDashboard,
  };
};

export default useVerificatedEmail;
